import { DialogContentText } from '@mui/material'

import { ConfirmDialog } from 'components/common'
import { CancellationOrLostDtoInput } from 'generated/graphql'

import { DeleteBookingDialog } from '../../DeleteBookingDialog'
import ConfirmCancellationOrLostDialog from '../ConfirmCancellationDialog/ConfirmCancellationOrLostDialog'

interface IProps {
  bookingId: string | undefined
  isQuote: boolean
  openConfirmCancellationOrLost: boolean
  openDeleteDialog: any
  openConfirmCompletion: any
  setOpenConfirmCompletion: React.Dispatch<React.SetStateAction<boolean>>
  setOpenConfirmCancellationOrLost: React.Dispatch<React.SetStateAction<boolean>>
  handleConfirmQuoteLost: (input: CancellationOrLostDtoInput) => void
  handleConfirmCancellation: (input: CancellationOrLostDtoInput) => void
  handleCloseDeleteDialog: () => void
  handleConfirmCompletion: () => void
}

const ConfirmationDialogs = ({
  bookingId,
  isQuote,
  openDeleteDialog,
  handleCloseDeleteDialog,
  openConfirmCancellationOrLost,
  setOpenConfirmCancellationOrLost,
  handleConfirmCancellation,
  handleConfirmQuoteLost,
  openConfirmCompletion,
  setOpenConfirmCompletion,
  handleConfirmCompletion,
}: IProps) => {
  return (
    <>
      {openDeleteDialog.open && bookingId && (
        <DeleteBookingDialog
          bookingId={Number(bookingId)}
          captionText={'Delete'}
          handleCloseDialog={handleCloseDeleteDialog}
          openDialog={openDeleteDialog.open}
          operationType={openDeleteDialog.operationType}
        />
      )}

      {openConfirmCancellationOrLost && (
        <ConfirmCancellationOrLostDialog
          bookingId={bookingId}
          open={openConfirmCancellationOrLost}
          isQuote={isQuote}
          setOpen={setOpenConfirmCancellationOrLost}
          onConfirmCancellation={handleConfirmCancellation}
          onConfirmQuoteLost={handleConfirmQuoteLost}
        />
      )}

      {openConfirmCompletion && (
        <ConfirmDialog
          title='Confirm Completion'
          open={openConfirmCompletion}
          setOpen={setOpenConfirmCompletion}
          onConfirm={handleConfirmCompletion}>
          <DialogContentText>
            The profit margin is less than 20%. Complete anyway?
          </DialogContentText>
        </ConfirmDialog>
      )}
    </>
  )
}

export default ConfirmationDialogs
